const descriptionTool = {
  activeColors: ['Aktywne Kolory', 'Wybieraj kolory; przytrzymaj, aby przesunąć Narzędziownik'],
  dilutionIndicator: ['Wskaźnik Rozcieńczenia', 'Kliknij i przeciągnij, aby zmienić poziom'],
  brushColor: ['Kolor Pędzla', 'Kliknij i przeciągnij, aby zmienić poziom'],
};

const descriptionMenu = {
  chalks: ['Kreda', '2 rozmiary kredy do szkicowania'],
  hogs: ['Hogi', '3 rozmiary pędzli Hog'],
  sobols: ['Sobole', '3 rozmiary pędzli Sobol'],
  rugs: ['Ściereczka', '2 rozmiary ściereczek do wycierania mokrej farby i kredy'],
  colorsPalette: ['Paleta Kolorów', 'Wybieraj 3 aktywne kolory do Narzędziownika'],
  menu: ['Menu'],
  custom: ['Presety', 'Użyj narzedzia na podstawie ustawień'],
  layers: ['Typ renderowania', 'Wybierz rodzaj modelu renderowania'],
};

const pl = {
  descriptionTool,
  descriptionMenu,
};

export default pl;
